import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RoleRightsService } from '../../../services/common/role-rights.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-action-cell-renderer',
  templateUrl: './action-cell-renderer.component.html',
  styleUrls: ['./action-cell-renderer.component.scss'],
})
export class ActionCellRendererComponent implements ICellRendererAngularComp {
  public displayValue!: any;
  public Data!: any;
  editWithModal = false;
  showEditButton = true;
  showDeleteButton = true;
  showViewButton = false;
  showAddButton = false;
  showEditRole = false;
  showRemoveButton = false;
  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canView: boolean = false;
  showEditRoleIcon = false;
  isLocked: boolean = false;

  constructor(
    private readonly roleRightsService: RoleRightsService,
    private readonly router: Router
  ) {}

  async agInit(params: ICellRendererParams): Promise<void> {
    this.displayValue = params;
    if (this.displayValue.ModuleName) {
      try {
        this.canAdd = await this.roleRightsService.hasAccess('isAdd');
        this.canEdit = await this.roleRightsService.hasAccess('isEdit');
        this.canDelete = await this.roleRightsService.hasAccess('isDelete');
        this.canView = await this.roleRightsService.hasAccess('isView');
        this.isLocked = this.displayValue.isLocked;
      } catch (err) {
        console.error('Error checking permissions:', err);
      }
    }
    this.showEditButton =
      this.displayValue.showEditButton ??
      (this.showEditButton && !this.isLocked);
    this.editWithModal =
      this.displayValue.editWithModal ?? (this.editWithModal && !this.isLocked);
    this.showAddButton = this.displayValue.showAddButton ?? this.showAddButton;
    this.showRemoveButton =
      this.displayValue.showDeleteButton ??
      (this.showRemoveButton && !this.isLocked);
    this.showEditRole =
      this.displayValue.showEditRole ?? (this.showEditRole && !this.isLocked);
    this.showDeleteButton =
      this.displayValue.showDeleteButton ??
      (this.showDeleteButton && !this.isLocked);
    this.showViewButton = this.displayValue.isLocked || this.displayValue.showViewButton;
    this.showAddButton = this.canAdd;
    this.displayValue.showEditRoleIcon ??
      (this.showEditRoleIcon && !this.isLocked);
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onActionClick(actionType: string, _id: string, data: any) {
    this.Data = data ? data : '';
    this.displayValue.clicked(
      actionType,
      _id,
      this.Data,
      this.displayValue.data.avatarPath
    );
  }

  navigateToEdit(employeePath: string, employeeId: string) {
    this.router.navigate([employeePath], {
      state: { id: employeeId },
    });
  }
}
